import { DateRange } from 'react-day-picker';

import format from 'date-fns/format';

import { HandleRangeParams } from './types';

export const handleRangeSelect = (range: DateRange | undefined, meta: HandleRangeParams) => {
  const { setSelectedRange, setToValue, setFromValue, dateFormat } = meta;

  setSelectedRange(range);

  if (range?.from) {
    setFromValue(format(range.from, dateFormat));
  } else {
    setFromValue('');
  }

  if (range?.to) {
    setToValue(format(range.to, dateFormat));
  } else {
    setToValue('');
  }
};
